import * as angular from 'angular';
import {IController} from 'angular';
import {$viewSettingsFactory} from "../../$viewSettings.factory";

export class BringozQuickFiltersSelectListComponent implements IController {
  selectedId: any;
  pageName: string;
  ngPlaceholder: any;
  onChange: Function;

  private quickFiltersRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;
  private excludeKeys: any;

  /* @ngInject */
  constructor(private $log, private $viewSettings: $viewSettingsFactory, private $infiniteScroll) {
  }

  $onInit() {
    this.quickFiltersRef = this.$viewSettings();
    this.loadLimit = 20;

    this.quickFiltersRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.quickFiltersRef, this.loadLimit, {getFullData: true});
  }

  $onChanges(changes) {

  }

  submitQuery(query) {
    this.queryString = query;
    this._reload();
  }

  onChangeFilter() {
    this.onChange({quickFilterId: this.selectedId, selectedItem:  this.infiniteScroll.getItem(this.selectedId)});
  }

  private _reload() {
    this.quickFiltersRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit:  this.loadLimit,
      query:  this.queryString,
      pageName: this.pageName,
      sort: 'name,asc'
    };
  }
}

angular
  .module('bringoz.admin.commons')
  .component('bringozQuickFiltersSelectList', {
    bindings: {
      selectedId: '<',
      pageName: '<',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./bringoz-quick-filters-select-list.html').default,
    controller: BringozQuickFiltersSelectListComponent
  });
